import { GeneralService, ApiKeyOrGetter } from "./GeneralService";

export interface CompassSearch {
  id: number;
  company_id: number;
  application_id: number;
  source_application_id: number;
  composition_id: number;
  base_model: string;
  training_method: string;
  accuracy_threshold: number;
  status: string;
  current_wave: number;
  max_waves: number;
  runs_per_wave: number;
  search_space: Record<string, unknown>;
  optimizer_state: Record<string, unknown> | null;
  best_run_id: number | null;
  best_accuracy: number | null;
  meta: Record<string, unknown> | null;
  date_created: number;
  date_completed: number | null;
  compass_app_name: string | null;
  source_app_name: string | null;
  composition_name: string | null;
  intent_name: string | null;
}

export interface CompassSearchRun {
  id: number;
  search_id: number;
  finetune_run_id: number;
  wave: number;
  hyperparameters: Record<string, unknown>;
  accuracy: number | null;
  loss_curve_analysis: {
    overfitting_score: number;
    underfitting_score: number;
    healthy: boolean;
  } | null;
  status: string;
  date_created: number;
  run_name: string | null;
  finetune_status: string;
  base_model: string;
}

export interface CreateCompassSearchRequest {
  source_application_id: number;
  intent_id?: number;
  composition_id: number;
  base_model: string;
  training_method: string;
  accuracy_threshold?: number;
  test_set_ids?: number[];
  evaluation_criteria_ids?: number[];
  max_waves?: number;
  runs_per_wave?: number;
  company_id?: number;
}

export class CompassService {
  public static getSearches(
    offset: number = 0,
    limit: number = 20,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter,
    companyId?: number | string
  ) {
    let url = `/compass/?offset=${offset}&limit=${limit}`;
    if (companyId) url += `&company_id=${companyId}`;
    return GeneralService.get(url, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
  }

  public static createSearch(
    data: CreateCompassSearchRequest,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/compass/",
      JSON.stringify(data),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }

  public static getSearchById(
    searchId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter,
    companyId?: number | string
  ) {
    let url = `/compass/${searchId}`;
    if (companyId) url += `?company_id=${companyId}`;
    return GeneralService.get(url, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
  }

  public static cancelSearch(
    searchId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter,
    companyId?: number | string
  ) {
    const qs = companyId ? `?company_id=${companyId}` : "";
    return GeneralService.post(
      `/compass/${searchId}/cancel${qs}`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSearchRuns(
    searchId: number,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: ApiKeyOrGetter,
    companyId?: number | string
  ) {
    let url = `/compass/${searchId}/runs`;
    if (companyId) url += `?company_id=${companyId}`;
    return GeneralService.get(url, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
  }
}
